import React from 'react';
import {Stack} from "@mui/material";

const ListOfRawData = () => {
    return (
        <Stack p={2} spacing={2} overflow={'auto'}>
            List of Raw Data Page
        </Stack>
    );
};

export default ListOfRawData;